import React from 'react';
import PropTypes from 'prop-types';

export const Spinner = ({ style, color = 'black' }) => (
  <div style={{ ...style, color }} className="spinner-border" role="status">
    <span style={{ display: 'none' }} />
  </div>
);

Spinner.propTypes = {
  style: PropTypes.object,
};

export default Spinner;
